import { Link } from 'react-router'
import { toast } from 'sonner'

export function FooterBar() {
  return (
    <footer className="border-t border-border/80 bg-black px-4 py-3 text-[12px] text-white md:px-6">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col gap-2 opacity-75 md:flex-row md:items-center md:gap-6">
          <span className="flex flex-wrap items-center gap-1.5">
            <span>designed and powered by</span>
            <img
              src="/branding/sitethreesixty-logo-nav.svg"
              alt="sitethreesixty"
              className="h-3.5 w-auto"
            />
            <span className="text-[#80EF80]">sitethreesixty</span>
          </span>
          <span>© 2026. All rights reserved.</span>
        </div>

        <div className="flex flex-wrap items-center gap-4 opacity-75">
          <button
            type="button"
            onClick={() => toast.info('The resource hub sitemap layer returns in the next content slice.')}
            className="cursor-pointer underline transition-colors hover:text-[#80EF80]"
          >
            Resource Hub
          </button>
          <Link to="/portal/privacy" className="underline transition-colors hover:text-[#80EF80]">
            Privacy
          </Link>
          <Link to="/portal/terms" className="underline transition-colors hover:text-[#80EF80]">
            Terms
          </Link>
          <Link to="/portal/security" className="underline transition-colors hover:text-[#80EF80]">
            Security
          </Link>
          <button
            type="button"
            onClick={() => toast.info('Sitemap view returns with the fuller portal content slice.')}
            className="cursor-pointer underline transition-colors hover:text-[#80EF80]"
          >
            Sitemap
          </button>
        </div>
      </div>
    </footer>
  )
}
